import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { compact } from 'lodash-es';
import { BottomSheetContentLayout, MobileSummaryCard, TextButton } from 'seagull';
import { PlusCircleLine } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
export const GetMobileFilterListTID = (parentTestId)=>getTestIds(parentTestId);
export const MobileFilterList = (param)=>{
    let { testId, filterLabels, filterDescriptions, draftFilterKeys, hasAvailableFilters, onRemoveFilter, onFilterClick, onAddFilterClick, onApply } = param;
    const { MobileFilterListTID } = useMemo(()=>GetMobileFilterListTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        contentGutter: "m",
        footer: {
            paddingTop: 8,
            primaryAction: {
                text: 'Apply',
                onClick: onApply,
                testId: MobileFilterListTID.ApplyButton()
            }
        },
        children: /*#__PURE__*/ _jsx(MobileSummaryCard, {
            title: "Filters",
            testId: MobileFilterListTID.Root(),
            items: compact([
                draftFilterKeys.length === 0 && {
                    body: 'No filters applied',
                    bodyTestId: MobileFilterListTID.NoFiltersApplied()
                },
                ...draftFilterKeys.map((filterKey)=>_object_spread_props(_object_spread({
                        title: filterLabels[filterKey],
                        titleTestId: MobileFilterListTID.FilterRow(String(filterKey))
                    }, (filterDescriptions === null || filterDescriptions === void 0 ? void 0 : filterDescriptions[filterKey]) && {
                        body: filterDescriptions[filterKey],
                        bodyEllipsis: true,
                        bodyTestId: MobileFilterListTID.FilterDescription(String(filterKey))
                    }), {
                        actions: [
                            {
                                type: 'edit',
                                testId: MobileFilterListTID.EditButton(String(filterKey)),
                                onClick: ()=>onFilterClick(filterKey)
                            },
                            {
                                type: 'remove',
                                testId: MobileFilterListTID.RemoveButton(String(filterKey)),
                                onClick: ()=>onRemoveFilter(filterKey)
                            }
                        ]
                    })),
                hasAvailableFilters && {
                    body: /*#__PURE__*/ _jsx(TextButton, {
                        testId: MobileFilterListTID.AddFilterButton(),
                        underline: "none",
                        weight: "normal",
                        prefixIcon: /*#__PURE__*/ _jsx(PlusCircleLine, {}),
                        onClick: onAddFilterClick,
                        children: "Add filter"
                    })
                }
            ])
        })
    });
};
